module.exports = __webpack_public_path__ + "static/graphik-medium-592620feba5083511d286af9642f95c6.woff2";